var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.95,
    height: 65.942,
    viewBox: "0 0 22.95 65.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scroll-down",
    transform: "translate(-948.525 -2513.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-mouse",
    "data-name": "Icon material-mouse",
    d: "M18.909,1.605V12.979H28.95A11.458,11.458,0,0,0,18.909,1.6ZM6,21.585a11.475,11.475,0,0,0,22.95,0V15.848H6ZM16.04,1.6A11.458,11.458,0,0,0,6,12.979H16.04V1.605Z",
    transform: "translate(942.525 2511.459)",
    fill: "#9ac099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M17.483,20.266l8.539-8.546a1.607,1.607,0,0,1,2.279,0,1.627,1.627,0,0,1,0,2.286l-9.675,9.682a1.611,1.611,0,0,1-2.225.047L6.658,14.013a1.614,1.614,0,1,1,2.279-2.286Z",
    transform: "translate(942.705 2542.175)",
    fill: "#9ac099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-2",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M17.483,20.266l8.539-8.546a1.607,1.607,0,0,1,2.279,0,1.627,1.627,0,0,1,0,2.286l-9.675,9.682a1.611,1.611,0,0,1-2.225.047L6.658,14.013a1.614,1.614,0,1,1,2.279-2.286Z",
    transform: "translate(942.705 2554.848)",
    fill: "#9ac099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-3",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M17.483,20.266l8.539-8.546a1.607,1.607,0,0,1,2.279,0,1.627,1.627,0,0,1,0,2.286l-9.675,9.682a1.611,1.611,0,0,1-2.225.047L6.658,14.013a1.614,1.614,0,1,1,2.279-2.286Z",
    transform: "translate(942.705 2542.175)",
    fill: "#9ac099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-4",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M17.483,20.266l8.539-8.546a1.607,1.607,0,0,1,2.279,0,1.627,1.627,0,0,1,0,2.286l-9.675,9.682a1.611,1.611,0,0,1-2.225.047L6.658,14.013a1.614,1.614,0,1,1,2.279-2.286Z",
    transform: "translate(942.705 2554.848)",
    fill: "#9ac099"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll-down.e4f214ba3826eb4078af2a0d4747a211.svg";
export { ForwardRef as ReactComponent };